const SESSION_KEY = code => `kart_session_${code}`
const SESSION_TTL_MS = 24 * 60 * 60 * 1000 // 24 h

export function getSession(code) {
  try {
    const raw = localStorage.getItem(SESSION_KEY(code))
    if (!raw) return null
    const stored = JSON.parse(raw)
    if (stored.exp && Date.now() > stored.exp) {
      localStorage.removeItem(SESSION_KEY(code))
      return null
    }
    return stored
  } catch {
    return null
  }
}

export function saveSession(code, token, kartId) {
  localStorage.setItem(SESSION_KEY(code), JSON.stringify({
    token,
    kartId,
    exp: Date.now() + SESSION_TTL_MS,
  }))
}

export function clearSession(code) {
  localStorage.removeItem(SESSION_KEY(code))
}
